import React from "react";

const ChrWidgetBody = (props) => {

  return (
    <div className={ props.className } >
      { props.children }
    </div>
  )
}

export default ChrWidgetBody;